/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

import './style/link.scss';
import classNames from 'classnames';
import React, {MouseEventHandler} from 'react';
import { NavigateFunction, useNavigate } from 'react-router';

interface Props {
    onClick?: MouseEventHandler;
    navigate?: NavigateFunction;
    route?: string;
    className?: string;
    disabled?: boolean;
    underline?: boolean;
    target?: string;
}

export default function Link(props: React.PropsWithChildren<Props>) {
    const {className, disabled, route, children, underline, target, onClick} = props;
    const navigate = props.navigate ?? useNavigate();

    function _onClick(evt: React.MouseEvent) {
        evt.preventDefault();
        if (!disabled) {
            if (route) {
                if (/^(www|http).+/.test(route)) window.open(route, target);
                else navigate(route);
            }
            if (onClick) onClick(evt);
        }
    }

    return (
        <a href={route} onClick={_onClick} target={target}
           className={classNames('app-link', className, disabled && 'disabled',
               underline && 'underline')}>{children}</a>
    );
};